import React from 'react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { TomoItem } from './TomoItem';
import { tomos } from '../data/tomos';
export function TomosSection() {
  return <section id="tomos" className="bg-mp-dark py-16 md:py-24 scroll-mt-16" data-id="element-292" data-mp="1p4lij4zavhpu">
      <Container data-id="element-293" data-mp="1u36j55igs3et">
        <div className="max-w-[700px]" data-id="element-294" data-mp="1u1lmnaclaaeb">
          <SectionTag tone="lime" data-id="element-295" data-mp="1u4rbqpl7xca1">La colección principal</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-296" data-mp="xdpemtv7wnep">
            Un sistema completo para tu trabajo en pista.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5" data-id="element-297" data-mp="16c10yjp1wz1c">
          {tomos.map((tomo, index) => <TomoItem key={tomo.number} tomo={tomo} index={index} data-id="element-298" data-mp="1bdgr2q635vql" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}